exports.NotificationType = {
  DISPLAY: 'DISPLAY',
  DATA: 'DATA',
  DISPLAY_WITH_DATA: 'DISPLAY_WITH_DATA',
}

exports.NotificationResult = {
  ACCEPTED: 'ACCEPTED',
  FAILED: 'FAILED',
}

exports.NotificationPreferenceType = {
  PICKUP_SCHEDULED: 'pickupScheduled',
  DROPOFF_SCHEDULED: 'dropoffScheduled',
  NEW_MESSAGE: 'newMessage',
  NEW_COURIER: 'newCourier',
  DONATION_REPORT: 'donationReport',
  DONATION_EDITED: 'donationEdited'
}

exports.NotificationPreferenceTypeList = [
  exports.NotificationPreferenceType.PICKUP_SCHEDULED,
  exports.NotificationPreferenceType.DROPOFF_SCHEDULED,
  exports.NotificationPreferenceType.NEW_MESSAGE,
  exports.NotificationPreferenceType.NEW_COURIER,
  exports.NotificationPreferenceType.DONATION_REPORT,
  exports.NotificationPreferenceType.DONATION_EDITED
]